import '@banno/jha-wc/src/progress/jha-progress/jha-progress';
import { css, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-loader';
@customElement(tagName)
export class TmLoader extends TmBaseComponent {
    @property({ type: Boolean })
    public card = false;

    @property({ type: Boolean })
    public reversed = false;

    @property({ type: String })
    public size: 'small' | 'medium' | 'large' = 'large';

    protected render() {
        const content = this.renderSpinnerContent();
        return this.card ? this.renderCardWrapper(content) : content;
    }

    private renderSpinnerContent() {
        if (this.reversed) {
            return html`<div class="${this.card ? 'spinner spinner--card' : 'spinner'}"></div>`;
        }
        return html`<jh-progress type="circular" size="${this.size}" indeterminate></jh-progress>`;
    }

    private renderCardWrapper(content: TemplateResult) {
        return html`<div class="card-loading">${content}</div>`;
    }

    public static get styles() {
        return css`
            @keyframes spin {
                100% {
                    transform: rotate(360deg);
                }
            }
            .spinner {
                width: 16px;
                height: 16px;
                border: 2px solid var(--jh-color-gray-0, #fff);
                border-right-color: transparent;
                border-radius: 50%;
                animation: spin 0.75s linear infinite;
            }
            .spinner--card {
                width: 28px;
                height: 28px;
                border-width: 4px;
            }
            .card-loading {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 32px 0;
                min-height: 200px;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmLoader;
    }
}
